import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={31}
    height={17}
    viewBox="0 0 31 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.43013 14.9205L0.779987 13.2704L0 14.0505L2.43007 16.4806L7.11026 11.7702L6.33028 10.9902L2.43013 14.9205Z"
      fill="#666666"
    />
    <path
      d="M0.689982 6.18983L2.85009 4.05982L4.98031 6.18983L5.67029 5.49984L3.54008 3.36963L5.67029 1.23962L4.98031 0.519531L2.85009 2.64975L0.689982 0.519531L0 1.23962L2.13022 3.36963L0 5.49984L0.689982 6.18983Z"
      fill="#666666"
    />
    <path
      d="M9.15234 0.519531V6.06982H30.0034V0.519531H9.15234ZM28.9234 5.01977H10.2324V1.59959H28.9234V5.01977Z"
      fill="#666666"
    />
    <path
      d="M9.15234 16.3901H30.0034V10.8398H9.15234V16.3901ZM10.2324 11.9198H28.9234V15.34H10.2324V11.9198Z"
      fill="#666666"
    />
  </svg>
);
export default SVGComponent;
